import BliIconSiSetting from '@blibli/blue-dls-library-icon/dist/Setting'
import BliIconSiPointsBlibli from '@blibli/blue-dls-library-icon/dist/PointsBlibli'
import BliIconSiCircleTierDiamond from '@blibli/blue-dls-library-icon/dist/CircleTierDiamond'
import BliIconSiChevronRight from '@blibli/blue-dls-library-icon/dist/ChevronRight'
import BliLoaderSkeleton from '@blibli/blue.loader-skeleton/dist/loader-skeleton/blue/LoaderSkeleton'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import { mapActions, mapState } from 'pinia'
import RewardsStore from '@vue3/store/rewards-store.js'
import CreditNoteStore from '@vue3/store/credit-note-store.js'
import AuthStore from '@vue3/store/auth-store.js'
import tracker from '@vue3/constants/tracker'
import { pages } from '@/config'
import { app } from '@vue3/configs'


const { ALLOCATE_POINT, VIEW_MISSION, VIEW_CREDIT_NOTE } = tracker.label

const { COMPANY_SECTION } = tracker.component

const { REDEEM_POINT, SEE_MISSION } = tracker.label

export default {
  name: 'EngagementInfo',
  components: {
    BliIconSiSetting,
    BliLoaderSkeleton,
    BliIconSiPointsBlibli,
    BliIconSiCircleTierDiamond,
    BliIconSiChevronRight
  },
  data () {
    return {
      enablePointsRetryOption: false
    }
  },
  mixins: [CommonMixin],
  created () {
    this.fetchEngagementInfo()
    this.fetchCreditNoteCount()
  },
  computed: {
    ...mapState(RewardsStore, ['showLoyaltySectionLoader']),
    ...mapState(CreditNoteStore, ['isCountFetching', 'isCreditNoteCountError', 'creditNoteCount']),
    ...mapState(AuthStore, ['getDealerId']),
    activeMissionCount () {
      return this.engagementInfo?.missionResponse?.activeMissionCount || 0
    }
  },
  methods: {
    ...mapActions(RewardsStore, ['getEngagementInfo']),
    ...mapActions(CreditNoteStore, ['getCreditNoteCount']),
    fetchEngagementInfo () {
      this.getEngagementInfo({
        param: { email: this.userDetails.email },
        success: this.onSuccessOfGetPoints,
        fail: this.onFailOfGetPoints
      })
    },
    fetchCreditNoteCount () {
      this.getCreditNoteCount({ params: { dealerId: this.getDealerId } })
    },
    onFailOfGetPoints () {
      this.enablePointsRetryOption = true
    },
    onSuccessOfGetPoints (res) {
      const errorCode = res?.memberLoyaltyResponse?.errorCode
      const isLoyaltyError = !!errorCode
      if (isLoyaltyError && errorCode !== 'COMPANY_ID_NOT_FOUND') {
        this.onFailOfGetPoints()
        return
      }
      this.enablePointsRetryOption = false
    },
    handleRewardActionClick () {
      if (this.enablePointsRetryOption) {
        this.fetchEngagementInfo()
        return
      }
      this.trackProfileAction(REDEEM_POINT)
      this.trackCompanySection(ALLOCATE_POINT)
      this.$router.push(pages.loyalty)
    },
    handleMissionActionClick () {
      this.trackProfileAction(SEE_MISSION)
      this.trackCompanySection(VIEW_MISSION)
      this.$router.push(pages.mission)
    },
    handleCreditNoteActionClick () {
      if (this.isCreditNoteCountError) {
        this.fetchCreditNoteCount()
        return
      }
      this.trackCompanySection(VIEW_CREDIT_NOTE)
      this.$router.push({ name: app.routerName.creditNote })
    },
    trackProfileAction (cp1) {
      if (this.isProfilePageRoute) {
        const trackValue = { cp1: cp1, trms_id: 'MIT1001-0001' }
        this.$trackButtonClick(COMPANY_SECTION, trackValue)
      }
    },
    trackCompanySection (cp1) {
      let trmsId = null

      if (this.isHomePageRoute) {
        trmsId = 'MIT1003-0002'
      } else if (this.isScanPageRoute) {
        trmsId = 'MIT1007-0021'
      }

      if (trmsId) {
        this.$trackButtonClick(COMPANY_SECTION, {
          cp1,
          trms_id: trmsId
        })
      }
    }
  }
}
